module.exports = __webpack_public_path__ + "img/35.5.COD.57d0175f.png";